<script setup lang="ts">
import type { MooncakeInfoType } from '@/types/one-year'
import { socketEmitAsync } from '@/utils/web-socket'
import { dayjs } from 'element-plus'
import { computed } from 'vue'
import { onMounted } from 'vue'
import { ref } from 'vue'
import { mooncakeList } from '../data'
import type { UserAttrType } from '@/types/user'
import { useUserStore } from '@/stores/modules/user'

const userStore = useUserStore()

const mooncakeInfo = ref<MooncakeInfoType>()
const curEatMooncakeInfo = computed(() => {
  if (!mooncakeInfo.value) return null
  if (dayjs().isAfter(dayjs(mooncakeInfo.value.expireDate || '1970-01-01'))) return null
  return mooncakeList.find((item) => item.id == mooncakeInfo.value?.id) || null
})
const canEat = computed(() => {
  if (!mooncakeInfo.value) return true
  return dayjs().isAfter(
    dayjs(mooncakeInfo.value.expireDate || '1970-01-01')
      .hour(0)
      .minute(0)
      .second(0),
  )
})
async function getMooncakeInfo() {
  const res = await socketEmitAsync<MooncakeInfoType>({ type: 'getMooncakeInfo' })
  mooncakeInfo.value = res
}
async function eatMooncake(item: { id: number; name: string; needCount: number; ad: number; classes: string }) {
  if (userStore.consumables.mooncakeMaterial < item.needCount) return ElMessage.warning('您的饺子原料不足')
  ElMessageBox.confirm(`是否食用<span class="${item.classes}">🥟 ${item.name}</span>？`, '提示', {
    type: 'warning',
    confirmButtonClass: 'is-plain',
    appendTo: 'body',
    dangerouslyUseHTMLString: true,
  })
    .then(async () => {
      const res = await socketEmitAsync<UserAttrType>({
        type: 'eatMooncake',
        data: { id: item.id },
      })
      userStore.userAttr = res
      mooncakeInfo.value = {
        id: item.id,
        expireDate: dayjs().add(1, 'day').format('YYYY-MM-DD 10:00:00'),
      }
      userStore.consumables.mooncakeMaterial -= item.needCount
      ElMessage.success(`成功食用${item.name}饺子，获得${item.ad}%全伤害加成，持续至明日10点`)
    })
    .catch(() => {})
}
onMounted(() => {
  getMooncakeInfo()
})
</script>

<template>
  <div class="mooncake">
    <div class="border-wrap affix">
      <h4>豪吃饺子</h4>
      <p>1. 节日庆典期间，参与<span class="info">共斗</span>即有概率掉落<span class="info">🥟 饺子原料</span>。</p>
      <p>
        2. 使用<span class="info">🥟 饺子原料</span>可用于合成各式饺子，并获得持续至<span class="info">明日 10:00</span>的<span class="grow"
          >全伤害加成</span
        >。
      </p>
      <p>3. 当存在已食用的饺子效果时，吃饺子将覆盖前一次的效果</p>
      <p>4. 每日仅可吃 <span class="shrink">1</span>份饺子，少吃多动，健康人生！</p>
      <br />
      <p style="display: flex; justify-content: space-between">
        <span>
          已食用：
          <span v-if="curEatMooncakeInfo" :class="curEatMooncakeInfo.classes">
            {{ curEatMooncakeInfo.name }}
          </span>
          <span v-else>（未食用）</span>
        </span>
        <span>🥟 {{ userStore.consumables.mooncakeMaterial }}</span>
      </p>
      <table border style="width: 100%; text-align: center">
        <tr>
          <th>饺子</th>
          <th>需求原料</th>
          <th>全伤害加成</th>
          <th>操作</th>
        </tr>
        <tr v-for="item of mooncakeList">
          <td :class="item.classes">🥟 {{ item.name }}</td>
          <td>{{ item.needCount }}</td>
          <td>{{ item.ad }}%</td>
          <td>
            <el-button type="primary" size="small" plain :disabled="!canEat" @click="eatMooncake(item)">吃！</el-button>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mooncake {
  .border-wrap {
    padding: 10px;
    p {
      font-size: 14px;
      margin: 5px 0;
    }
  }
  table {
    th {
      padding: 5px 0;
    }
    td {
      padding: 2px 0;
    }
  }
}
</style>
